import { formatMinutes } from "../../format-minutes.js";
import "react";
import { DataDisplay } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/occurrence/cadence/CadenceOccurrenceDisplay.tsx
function CadenceOccurrenceDisplay({ occurrence }) {
	return /* @__PURE__ */ jsxs(DataDisplay, {
		dividers: "space",
		space: "xs",
		children: [
			/* @__PURE__ */ jsx(DataDisplay.Item, {
				label: "Occurrence",
				children: "Cadence"
			}),
			/* @__PURE__ */ jsx(DataDisplay.Item, {
				label: "Every",
				children: formatMinutes(occurrence.cadenceMinutes)
			}),
			/* @__PURE__ */ jsx(DataDisplay.Item, {
				label: "Buffer",
				children: occurrence.bufferMinutes === 0 ? "None" : formatMinutes(occurrence.bufferMinutes)
			})
		]
	});
}
//#endregion
export { CadenceOccurrenceDisplay };

//# sourceMappingURL=CadenceOccurrenceDisplay.js.map